import React, { useEffect } from 'react';
import bgImage from '../assets/IMG_3902.JPG.jpeg';

const Background = ({ children }) => {
  // Force dark mode for all pages wrapped in Background (home, registration, etc.)
  // This ensures these pages always use dark mode regardless of theme setting
  // Works on both desktop and mobile devices
  useEffect(() => {
    // Set dark theme on document root - applies globally to all devices
    document.documentElement.setAttribute('data-theme', 'dark');
    
    return () => {
      // Restore theme from localStorage when component unmounts
      // This allows dashboard theme preference to be restored when navigating away
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        document.documentElement.setAttribute('data-theme', savedTheme);
      }
    };
  }, []);

  return (
    <div className="bg-wrapper">
      <div
        className="bg-container"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      />
      <div className="bg-overlay" />
      {children && <div className="background-content">{children}</div>}
    </div>
  );
};

export default Background;
